// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news {
  width: 100%;
  margin: 0 auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.news__wrapper {
  padding: 20px 0;
  width: 90%;
  margin: 0 auto;
  gap: 14px;
  border-bottom: 1px dotted #828588;
}

.news__wrapper:last-of-type {
  border: none;
}

.news__container {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px 0;
}

.news__block-img {
  position: relative;
  width: 40%;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
}

.news__photo {
  display: block;
  width: 77%;

  object-fit: cover;
  cursor: zoom-in;
}

.news__video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.news__button {
  width: 70%;
  font-family: Oswald-Light, sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding: 1px 15px;
  border: 1px solid #7e7b7b;
  background-size: cover;
  background-position: center;
}

.arrow {
  width: 20px;
  height: 20px;
}

@media (hover: hover) {
  .arrow:hover {
    background-color: #656768;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }
}

.news__block {
  display: grid;
  grid-template-rows: 1fr 1fr;
  justify-items: start;
  align-items: center;
  gap: 15px;
}

.news__block-info {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}

.news__title {
  margin: 0;
  font-size: 0.6em;
  font-family: Oswald-Light, sans-serif;
  line-height: 1.55;
  text-align: start;
  text-transform: uppercase;
}

.news__time {
  margin: 0;
  padding: 0;
  color: #073042;
  font-size: 14px;
  font-family: Oswald-Light, sans-serif;
  text-align: start;
}

.news__place {
  font-family: Oswald-Light, sans-serif;
  font-size: 0.6em;
  font-weight: 400;
  margin: 0;
}

.news__link {
  font-family: Oswald-Light, sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding: 1px 15px;
  border: 1px solid #7e7b7b;
  background-size: cover;
  background-position: center;
}

.news__link:hover {
  background-color: #ebf3f7;
}

@media screen and (max-width: 985px) {
  .news__wrapper {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .news__wrapper {
    padding: 0;
  }
  .news__button {
    width: 70%;
    font-family: Oswald-Light, sans-serif;
    font-size: 12px;
    font-weight: 400;
    padding: 1px 5px;
    border: 1px solid #7e7b7b;
    background-size: cover;
    background-position: center;
  }
  
  .arrow {
    width: 15px;
    height: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/News/News.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,UAAU;;EAEV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".news {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.news__wrapper {\r\n  padding: 20px 0;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  gap: 14px;\r\n  border-bottom: 1px dotted #828588;\r\n}\r\n\r\n.news__wrapper:last-of-type {\r\n  border: none;\r\n}\r\n\r\n.news__container {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 15px;\r\n  padding: 15px 0;\r\n}\r\n\r\n.news__block-img {\r\n  position: relative;\r\n  width: 40%;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: flex-end;\r\n}\r\n\r\n.news__photo {\r\n  display: block;\r\n  width: 77%;\r\n\r\n  object-fit: cover;\r\n  cursor: zoom-in;\r\n}\r\n\r\n.news__video-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.news__button {\r\n  width: 70%;\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  padding: 1px 15px;\r\n  border: 1px solid #7e7b7b;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n.arrow {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n@media (hover: hover) {\r\n  .arrow:hover {\r\n    background-color: #656768;\r\n    border-radius: 50%;\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n.news__block {\r\n  display: grid;\r\n  grid-template-rows: 1fr 1fr;\r\n  justify-items: start;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.news__block-info {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 20px;\r\n}\r\n\r\n.news__title {\r\n  margin: 0;\r\n  font-size: 0.6em;\r\n  font-family: Oswald-Light, sans-serif;\r\n  line-height: 1.55;\r\n  text-align: start;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.news__time {\r\n  margin: 0;\r\n  padding: 0;\r\n  color: #073042;\r\n  font-size: 14px;\r\n  font-family: Oswald-Light, sans-serif;\r\n  text-align: start;\r\n}\r\n\r\n.news__place {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 0.6em;\r\n  font-weight: 400;\r\n  margin: 0;\r\n}\r\n\r\n.news__link {\r\n  font-family: Oswald-Light, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  padding: 1px 15px;\r\n  border: 1px solid #7e7b7b;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n.news__link:hover {\r\n  background-color: #ebf3f7;\r\n}\r\n\r\n@media screen and (max-width: 985px) {\r\n  .news__wrapper {\r\n    margin: 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .news__wrapper {\r\n    padding: 0;\r\n  }\r\n  .news__button {\r\n    width: 70%;\r\n    font-family: Oswald-Light, sans-serif;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    padding: 1px 5px;\r\n    border: 1px solid #7e7b7b;\r\n    background-size: cover;\r\n    background-position: center;\r\n  }\r\n  \r\n  .arrow {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
